module.exports = __webpack_public_path__ + "img/ic_hotel_roomservice.87534f3a.png";